import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { Item, OrderStatusItem } from '../../data/data.generated';
import { TableResult, TableView } from './table';
import { OrderStatusAttachment } from '../../components/order-status-attachments/order-status-attachments.component';

export class OrderStatus {
  constructor(private _api: ApiService) {}

  public GetItems(listOptions: TableView): Observable<TableResult<Item>> {
    return this._api.Get<TableResult<Item>>('GetItems', {
      ...listOptions,
    });
  }

  public GetOrderStatusItems(
    listOptions: TableView,
  ): Observable<TableResult<OrderStatusItem>> {
    return this._api.Post('GetOrderStatusItems', listOptions);
  }

  public UpdateOrderStatus(id: number, shippingShortage: boolean) {
    return this._api.Post('UpdateOrderStatus', {
      Id: id,
      ShippingShortage: shippingShortage,
    });
  }

  public DownloadOrderStatusAttachment(
    attachment: OrderStatusAttachment,
    finished: (err: string) => void,
  ) {
    let mimeType = 'application/octet-stream'; // Default to binary stream
    if (attachment.FileName.toLowerCase().endsWith('pdf')) {
      mimeType = 'application/pdf';
    } else if (attachment.FileName.toLowerCase().endsWith('png')) {
      mimeType = 'image/png';
    } else if (attachment.FileName.toLowerCase().endsWith('jpeg')) {
      mimeType = 'image/jpeg';
    } else if (attachment.FileName.toLowerCase().endsWith('jpg')) {
      mimeType = 'image/jpg';
    }

    this._api.Download(
      'DownloadOrderStatusAttachment',
      {
        Id: attachment.Id,
      },
      attachment.FileName,
      mimeType,
      finished,
    );
  }

  public GetOrderStatusAttachments(id: number): Observable<any> {
    return this._api.Get('GetOrderStatusAttachments', {
      Id: id,
    });
  }

  public UploadOrderStatusAttachments(
    id: number,
    files: File[],
  ): Observable<any> {
    return this._api.Post(
      'UploadOrderStatusAttachments',
      {
        Id: id,
      },
      files,
    );
  }

  public DeleteOrderStatusAttachment(attachmentId: number) {
    return this._api.Get<string>('DeleteOrderStatusAttachment', {
      AttachmentId: attachmentId,
    });
  }

  public ExportOrderStatusItems(listOptions: TableView, tabName?: string) {
    var params: any = {
      ...listOptions,
      Filters: JSON.stringify(listOptions.Filters),
    };

    let date = new Date().toLocaleString('en-US');

    this._api.Download(
      'ExportOrderStatusItems',
      params,
      `${tabName ?? ''} Export ${date}`,
      'text/csv',
      (err: string) => {},
    );
  }
}
